import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import FilterSortElementViewModelT from '@/ViewModels/Controls/FilterSortElementViewModel';
import DropDownListT from '@/Controls/DropDownList';
import LinkT from '@/Controls/Link';
import LabelT from '@/Controls/Label';
import Utilities from '@/Utility/Utilities';

export default class FilterSortElement extends Control {
    private DropDownList = ComponentManager.getControl<typeof DropDownListT>('DropDownList');
    private Link = ComponentManager.getControl<typeof LinkT>('Link');
    private Label = ComponentManager.getControl<typeof LabelT>('Label');

    private $control: JQuery;

    public constructor(private viewModel: FilterSortElementViewModelT, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.$control != null) {
            return this.$control;
        }

        this.$control = this.element || $('<div>');

        $('<div class="sort_index_label">').appendTo(this.$control);
        $('<div class="sort_column">').appendTo(this.$control);
        $('<div class="sort_direction">').appendTo(this.$control);

        this.widget(null);

        return this.$control;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.$control, {
            controlName: 'filtersortelement',

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    return states;
                }
            })
        });

        if (this.viewModel.sortColumnList != null) {
            let sortColumnDropDownList = new this.DropDownList(this.viewModel.sortColumnList);
            let tuple = sortColumnDropDownList.getTuple();

            let $sortColumnList = tuple.control;
            this.applyBindings($sortColumnList, {
                locator: this.viewModel.sortColumnList.locator
            });
            $sortColumnList.appendTo(this.$control.find('.sort_column'));
        }

        if (this.viewModel.sortDirectionLink != null) {
            let sortDirectionLink = new this.Link(this.viewModel.sortDirectionLink);
            let tuple = sortDirectionLink.getTuple();

            let $sortDirectionLink = tuple.control;
            this.applyBindings($sortDirectionLink, {
                locator: this.viewModel.sortDirectionLink.locator
            })
            $sortDirectionLink.appendTo(this.$control.find('.sort_direction'));
        }

        if (this.viewModel.indexLabel != null) {
            let indexLabel = new this.Label(this.viewModel.indexLabel);
            let tuple = indexLabel.getTuple();

            let $indexLabel = tuple.control;
            this.applyBindings($indexLabel, {
                locator: this.viewModel.indexLabel.locator
            });
            $indexLabel.appendTo(this.$control.find('.sort_index_label'));
        }
    }
}

ComponentManager.setControl('FilterSortElement', FilterSortElement, 'RADPresentation.HTMLClient.DefaultViewExtensions');